import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import GroupsManager from "@/components/GroupsManager";
import { ArrowLeft } from "@phosphor-icons/react";

export default function TournamentGroups() {
  const { id } = useParams();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    api.get(`/tournaments/${id}`).then(({ data }) => setEvent(data)).catch(() => {});
  }, [id]);

  return (
    <div className="space-y-4" data-testid="tournament-groups-page">
      <Link to={`/dashboard/torneos`} className="inline-flex items-center text-gray-400 hover:text-[#CCFF00] text-sm">
        <ArrowLeft size={16} className="mr-1" /> Volver a Torneos
      </Link>
      <GroupsManager
        eventKind="tournament"
        eventId={id}
        eventName={event?.name || "Torneo"}
        category={event?.category || ""}
      />
    </div>
  );
}
